"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResult = exports.SearchResult = void 0;
const app_1 = require("app");
const SearchResult_1 = require("./SearchResult");
const dictionary_1 = require("./dictionary");
const constants_1 = require("./constants");
class SearchResult extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.search-results-page';
    }
    OnInit() {
        const searchResultElement = this.el[0];
        const tabsLabels = app_1.AttrService.data(searchResultElement, 'tab-labels') || {};
        const tabsConfig = app_1.AttrService.data(searchResultElement, 'search-config') || [];
        const tabsConfigWithLabels = (Array.isArray(tabsConfig) ? tabsConfig : []).map((tab) => {
            var _a;
            return (Object.assign(Object.assign({}, tab), { title: (_a = tabsLabels[tab.key]) !== null && _a !== void 0 ? _a : tab.key }));
        });
        const dictionary = (0, app_1.transformDictionary)(dictionary_1.searchPageDictionary, app_1.AttrService.data(searchResultElement, 'dictionary') || []);
        const filterDictionary = (0, app_1.transformDictionary)(dictionary_1.searchPageFilterDictionary, app_1.AttrService.data(searchResultElement, 'filter-dictionary') || []);
        const rawLanguage = app_1.AttrService.data(searchResultElement, 'search-api-language');
        const language = typeof rawLanguage === 'string' && rawLanguage ? rawLanguage : constants_1.CHINA_LOCALE;
        const languageParts = language.split('_');
        const rawCulture = app_1.AttrService.data(searchResultElement, 'culture');
        const culture = typeof rawCulture === 'string' && rawCulture ? rawCulture.toLowerCase() : constants_1.CHINA_LOCALE;
        app_1.DateService.setLocale(culture);
        const rawIsDocumentPage = app_1.AttrService.data(searchResultElement, 'is-documents-search-page');
        const isDocumentPage = typeof rawIsDocumentPage === 'boolean'
            ? rawIsDocumentPage
            : typeof rawIsDocumentPage === 'string' && rawIsDocumentPage.toLowerCase() === 'true';
        const rawDocumentPreselectedLanguages = app_1.AttrService.data(searchResultElement, 'preselected-languages-documents');
        const documentPreselectedLanguages = Array.isArray(rawDocumentPreselectedLanguages)
            ? rawDocumentPreselectedLanguages.map(language => typeof language === 'string' ? language.split('_')[0] : constants_1.CHINA_LOCALE)
            : [];
        const configData = {
            culture,
            portfolioApiUrl: app_1.AttrService.data(searchResultElement, 'portfolio-api-url'),
            algoliaAnalyticsTags: app_1.AttrService.data(searchResultElement, 'algolia-analytics-tags') || [],
            locationApiUrl: app_1.AttrService.data(searchResultElement, 'location-api-url'),
            locationApiKey: app_1.AttrService.data(searchResultElement, 'location-api-key'),
            language: languageParts[0],
            languageCode: language.replace('_', '-'),
            zeroResultMessage: app_1.AttrService.data(searchResultElement, 'zero-results-message'),
            gtmPageName: app_1.AttrService.data(searchResultElement, 'gtm-page') || constants_1.GTM_PAGE_NAME,
            isDocumentPage,
            documentPreselectedLanguages,
        };
        (0, SearchResult_1.RenderSearchResult)(searchResultElement, {
            tabsConfig: tabsConfigWithLabels,
            configData: configData,
            dictionary: Object.assign(Object.assign({}, dictionary), filterDictionary),
        });
    }
}
exports.SearchResult = SearchResult;
exports.searchResult = new SearchResult();
